var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-head"},[_c('i',{staticClass:"icon icon-arrow-left",on:{"click":_vm.goBack}}),_c('span',{staticClass:"m-tit"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"m-more"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }